import { EventType } from "../features/balancing/types/BalancingCore";
import { IdBuilding } from "./IdBuilding";
export var mapBuildingIdToDiscountEvent = new Map([
    [IdBuilding.FancyHouse, EventType.FancyHouseDiscount],
    [IdBuilding.FertileAcre, EventType.FertileAcreDiscount],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapBuildingIdToDiscountEvent.ts
// module id = 1248
// module chunks = 3